<template>
  <div id="fivePart">
    <div class="titlePart">
      <h2 class="title">南京桥工段</h2>
      <div class="intro">
          南京桥工段主要承担南京长江大桥、芜湖长江大桥、南京大胜关长江大桥3座长江特大桥，京沪、沪蓉、仙宁、宁杭、宁安高铁，沪宁高铁城际场、南京和南京南动车所，以及既有京沪、宁芜、淮南线(普速)及尧化门编组场等站场线路养护维修。
      </div>
    </div>
    <div class="casebutlist">
      <div
        class="caseButton wow animate__zoomIn"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="imgBox">
      <el-image  class="secondImg" :src="srcArr[0]" :preview-src-list="srcArr"></el-image>
    </div>

  </div>
</template>

<script>
import Viewer from "../viewer/viewer.vue";
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {
      list: [
        "视频烟火分析系统",
        "视频系统",
      ],
      srcArr:[
          require('../../assets/img/case/1.png'),
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {},
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#fivePart {
  padding: 5% 14%;
  .titlePart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      line-height: 4.2rem;
      margin-bottom: 1rem;
    }
    .intro {
      width: 75%;
      color: #999999;
      text-align: justify;
      text-justify: inter-ideograph; /*IE*/
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    }
  }
  .casebutlist {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 36%;
    margin: 2rem 0;
    .caseButton {
      background: #ffffff;
      color: #00a087;
      padding: 0.5rem 3rem;
      border-radius: 24px;
      font-size: 1.4rem;
      font-weight: bold;
      letter-spacing: 0.15rem;
      margin: 1rem;
      box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
      cursor: pointer;
    }
  }
  .imgBox {
    margin-bottom: 5rem;
    width: 70%;
    height: 50rem;
    margin-left: 15%;
    .secondImg {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../assets/responsive/case.scss";
</style>
